var OrderOptionTypeModel = function (pageModelHndl) {
    var that = this;

    //baseData
    that.TypeId = ko.observable();
    that.TypeName = ko.observable();
    that.OrderOptions = ko.observableArray([]);
    that.OnlyForExtension = ko.observable();
    that.IsEnabled = ko.observable();

    //flags
    that.IsValueStatic = ko.observable(false);

    //subData
    that.SelectedOrderOptionId = ko.observable();

    //computed
    that.IsVisible = ko.computed(function () {
        return !that.IsValueStatic() && that.IsEnabled();
    }, this);

    //functions
    that.ReInjectDeliveryTimeType = function (basePrice) {
        that.ReInjectDeliveryTimes(basePrice);
    };

    that.InjectDeliveryTimeType = function (basePrice) {
        that.TypeId(-1);
        that.TypeName("Lieferzeit"); //TODO: remove magic string

        that.InjectDeliveryTimes(basePrice);
    };

    that.ReInjectDeliveryTimes = function (basePrice) {
        $.each(pageModelHndl.pPriceTableModel.ProductionTypes(), function (i, prodType) {
            //inject data into first element
            ((that.OrderOptions())[i]).ReInjectDeliveryTime(prodType, i, basePrice);
        });
    };

    that.InjectDeliveryTimes = function (basePrice) {
        that.OrderOptions([]);

        $.each(pageModelHndl.pPriceTableModel.ProductionTypes(), function (i, prodType) {
            if (i == 0) {
                that.SelectedOrderOptionId(prodType.ProductionTypeId());
            }

            var orderOption = new OrderOptionModel(pageModelHndl);
            orderOption.InjectDeliveryTime(prodType, i, basePrice);

            that.OrderOptions.push(orderOption);
        });
    };

    that.RePopulateOrderOptionTypeModel = function (orderOptionTypeData) {
        that.RePopulateOrderOptions(orderOptionTypeData.OrderOptions);
    };

    that.PopulateOrderOptionTypeModel = function (orderOptionTypeData, selectedOrderOptions) {
        that.TypeId(orderOptionTypeData.TypeName.Key);
        that.TypeName(orderOptionTypeData.TypeName.Text);

        that.PopulateOrderOptions(orderOptionTypeData.OrderOptions, selectedOrderOptions);
    };

    that.RePopulateOrderOptions = function (orderOptions) {
        $.each(orderOptions, function (i, orderOptionData) {
            ((that.OrderOptions())[i]).RePopulateOrderOptionModel(orderOptionData);
        });
    };

    that.PopulateOrderOptions = function (orderOptions, selectedOrderOptions) {
        that.OrderOptions([]);

        var selectedOrderOptionIdSet = false;
        $.each(orderOptions, function (i, orderOptionData) {
            if (selectedOrderOptionIdSet) {
                if (selectedOrderOptions != undefined) {
                    if (selectedOrderOptions.indexOf(orderOptionData.OrderOptionId) > -1) {
                        that.SelectedOrderOptionId(orderOptionData.OrderOptionId);
                    }
                }
            } else if (orderOptionData.Enabled) {
                that.SelectedOrderOptionId(orderOptionData.OrderOptionId);
                selectedOrderOptionIdSet = true;
            }

            var orderOption = new OrderOptionModel(pageModelHndl);
            orderOption.PopulateOrderOptionModel(orderOptionData);

            that.OrderOptions.push(orderOption);
        });
    };

    that.VisibleOrderOptions = ko.computed(function () {
        var filteredArray = [];

        $.each(that.OrderOptions(), function (index, item) {
            if (item.Enabled())
                filteredArray.push(item);
        });
        return filteredArray;
    }, this);
};